import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, NgForm } from '@angular/forms';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { generate } from 'rxjs';
import { MailService } from '../../services/mail.service';
import { CommonModule } from '@angular/common';
import { Validators } from '@angular/forms';
import { CopyTextDirective } from '../../directives/copy-text.directive';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [TranslateModule, FormsModule, CommonModule, CopyTextDirective],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.css',
})
export class ContactComponent {
  constructor(private mailService: MailService) {}

  private color: string = '';
  showAlert: boolean = false;
  alertMessage: string = '';
  onSubmit: boolean = false;

  contactFormValues = {
    name: '',
    email: '',
    message: '',
  };

  get alertColor() {
    return `text-${this.color}-400`;
  }

  hideAlert() {
    setTimeout(() => {
      this.showAlert = false;
    }, 5000);
  }

  async submitEmail(contactForm: NgForm) {
    this.onSubmit = true;
    let formData: FormData = new FormData();
    formData.append('name', this.contactFormValues.name);
    formData.append('email', this.contactFormValues.email);
    formData.append('body', this.contactFormValues.message);

    formData.append('access_key', '3a75140d-80c5-4085-886c-b688f84839ff');
    formData.append('subject', 'Wiadomość z formularza ze strony');
    formData.append('from_name', 'Contact Notification');
    console.log(contactForm.value);

    try {
      // -- send email
      const res = await this.mailService.sendEmail(formData);
      if (!res.ok) {
        throw new Error();
      }
      this.alertMessage = 'Email sent successfully!';
      this.color = 'green';
      contactForm.reset();
    } catch (err) {
      // handle error
      this.alertMessage = 'Something went wrong, try again later!';
      this.color = 'red';
    }
    // -- reset submit and hide alert
    this.onSubmit = false;
    this.showAlert = true;
    this.hideAlert();
  }
}
